import type { PaymentDataDTO } from './dto-client'
import type { PaymentPlan } from './PaymentPlan'

export interface PaymentData {
    purchaseAmount: number
    paymentCycleDates: number[]
    successUrl: string
    errorUrl: string
    siteUrl: string
    paymentPlans: PaymentPlan[]
    showCoupon: boolean
    pendingApproval: boolean
    pendingSisbonCheck: boolean
    incomeLimit: number
    gracePaymentCycleDates: number[]
    maxGlobalTotalLoanAmountLimit: number
    maxGlobalTotalLoanAmountCpiIncludedLimit: number
    minGlobalTotalLoanAmountLimit: number
}

/**
 * Maps the PaymentDataDTO wire shape to the normalized PaymentData used by
 * consumers. Sorts payment plans (possible first, then by descending months)
 * and defaults missing cycle-date arrays to empty. Replaces the former
 * PaymentData model class.
 */
export const toPaymentData = (data: PaymentDataDTO): PaymentData => ({
    purchaseAmount: data.purchaseAmount,
    paymentCycleDates: data.paymentCycleDates ?? [],
    successUrl: data.successUrl,
    errorUrl: data.errorUrl,
    siteUrl: data.siteUrl,
    paymentPlans: [...data.paymentPlans].sort((a, b) => {
        if (a.possible === b.possible) {
            if (a.termMaturity.numberOfMonths > b.termMaturity.numberOfMonths) return -1
            if (a.termMaturity.numberOfMonths < b.termMaturity.numberOfMonths) return 1
            return 0
        }
        return a.possible ? -1 : 1
    }),
    showCoupon: data.showCoupon,
    pendingApproval: data.pendingApproval,
    pendingSisbonCheck: data.pendingSisbonCheck,
    incomeLimit: data.incomeLimit,
    gracePaymentCycleDates: data.gracePaymentCycleDates ?? [],
    maxGlobalTotalLoanAmountLimit: data.maxGlobalTotalLoanAmountLimit,
    maxGlobalTotalLoanAmountCpiIncludedLimit: data.maxGlobalTotalLoanAmountCpiIncludedLimit,
    minGlobalTotalLoanAmountLimit: data.minGlobalTotalLoanAmountLimit,
})
